import { Grid, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import moment from "moment"
import React from "react"

const SessaoExpira = (props) => {
	const classes = useStyles()
	const horaExpiracao = moment(props.dataExpiracao).format("HH:mm")

	return (
		<Grid container alignItems="center" direction="row" spacing={1} justify="center">
			<Grid item className={classes.wrap} xs={12} sm={12} md={12} lg={12}>
				<Typography id="sessao" className={classes.sessaoAtiva}>
					Sessão expira às
				</Typography>
				<Typography id="horaExpiracao" className={classes.horarioExpiracao}>
					{horaExpiracao}
				</Typography>
			</Grid>
		</Grid>
	)
}

const useStyles = makeStyles({
	sessaoAtiva: {
		color: "#61688B",
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		fontSize: "9pt",
	},
	horarioExpiracao: {
		fontWeight: "bold",
		color: "#61688B",
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		fontSize: "11pt",
		letterSpacing: "1px",
	},
	wrap: {
		textAlign: "center",
	},
})

export default SessaoExpira
